@if (totalIncidentCount > 0) {
  <div class="col-12 col-lg-5 col-xl-4 mb-2">
    <gtapp-auto-complete
      [data]="incidentDropDownList"
      placeHolder="Search Incidents"
      searchKeyword="company_name"
      [itemTemplate]="incidentTemplate"
      [initialValue]="incidentSearchString"
      (inputChanged)="onIncidentLookup($event)"
      (selected)="openIncidentView($event)"
      (submitted)="
        clearValues(); incidentSearchString = $event; getIncidentListData()
      "
    >
    </gtapp-auto-complete>
    <ng-template #incidentTemplate let-item>
      <div>
        {{ item?.incident_type }}
        @if (item?.incident_key) {
          <span>[{{ item?.incident_key }}]</span>
        }
      </div>
      <div class="fw-semibold">{{ item?.site_name }}</div>
      @if (item?.full_address) {
        <div class="text-secondary small-font">
          {{ item?.full_address }}
        </div>
      }
    </ng-template>
  </div>
}

<gtapp-gt-custom-table
  [deskTopTableData]="incidentPaginationData[pageNumIncidents] || []"
  [desktopTableDetails]="incidentDetailsTableView"
  [tableStyle]="tableStyle"
  [otherParams]="otherParamsIncidents"
  (sortColumn)="sortColumnIncident($event)"
  (searchColumn)="searchColumnIncident($event)"
  (rowClick)="openIncidentView($event)"
  (paginationChange)="onChangePaginationIncident($event)"
></gtapp-gt-custom-table>
